import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { State } from '../../store';
import { logOut } from '../../store/auth/authActions';
import useDesktopSize from '../../../utils/hooks/useDesktopSize';
import EAButton from '../shared/Buttons/EAButton';
import EAIconButton from '../shared/Buttons/EAIconButton';
import { MdOutlineLogout } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

const MyAccountHeader: React.FC = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state: State) => state.auth.userData);
  const isDesktop = useDesktopSize();
  const { t } = useTranslation();

  const handleLogout = () => {
    dispatch(logOut());
  };

  return (
    <div className="my-account-v2__header">
      <h2>{t("czesc")}, {userData.firstName}</h2>
      {isDesktop ? (
        <EAButton title={t("wyloguj_sie")} onClick={handleLogout} variant="text" endIcon={<MdOutlineLogout />} />
      ) : (
        <EAIconButton title={t("wyloguj_sie")} icon={<MdOutlineLogout />} onClick={handleLogout} variant="icon" />
      )}
    </div>
  );
};

export default MyAccountHeader;
